var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { memo } from 'react';
import { withSkeleton } from '../../Skeleton';
import styled from '../../utils/styled-components';
import { OwnSkeleton, ComponentWrapper } from '../styles';
var RectForeground = styled.rect(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  clip-path: ", ";\n  fill: ", ";\n"], ["\n  width: ", ";\n  clip-path: ", ";\n  fill: ", ";\n"])), function (_a) {
    var width = _a.width;
    return width;
}, function (_a) {
    var clipPath = _a.clipPath;
    return clipPath;
}, function (_a) {
    var theme = _a.theme;
    return theme.component.product.rating.background;
});
var RatingWrapper = styled(ComponentWrapper)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  /* SVG gets too much line-height so it has to be restricted */\n  line-height: 0;\n"], ["\n  /* SVG gets too much line-height so it has to be restricted */\n  line-height: 0;\n"])));
/** Creates either the star or the shoe SVG consisting of 5 path objects */
var ratingSvg = function (ratingValue, ratingSymbol, maxWidth) {
    return (React.createElement("svg", { viewBox: ratingSymbol === 'shoe' ? '0 0 160 32' : '0 0 180 36', style: {
            maxWidth: maxWidth,
            verticalAlign: 'top',
            maxHeight: '1.3rem',
        }, "data-testid": ratingSymbol === 'shoe' ? 'rating-shoes' : 'rating-stars' },
        React.createElement("defs", null,
            React.createElement("polygon", { id: ratingSymbol, points: ratingSymbol === 'shoe'
                    ? '1.092 27.128, 1.674 25.756, 8.090 21.768, 10.126 20.229, 13.588 19.928, 15.079 18.395, 19.159 12.259, 22.076 7.351, 25.866 3.842, 27.320 2.134, 30.238 5.815, 30.820 10.104, 29.947 12.870, 29.648 17.773, 29.066 24.838, 27.321 24.838, 27.321 14.718, 26.449 14.718, 24.406 17.168, 22.077 23.610, 18.871 26.985, 12.462 27.442, 1.676 27.442, 1.094 27.129'
                    : '18.000 28.319, 7.223 34.875, 10.020 22.420, 0.562 14.017, 13.068 12.875, 18.000 1.126, 22.932 12.875, 35.438 14.017, 25.980 22.420, 28.777 34.875' }),
            React.createElement("clipPath", { id: ratingSymbol + "s" }, Array.from({ length: 5 }, function (v, i) { return (React.createElement("use", { key: i, href: "#" + ratingSymbol, xlinkHref: "#" + ratingSymbol, x: i * 20 + "%" })); }))),
        React.createElement("rect", { width: "100%", height: "100%", clipPath: "url(#" + ratingSymbol + "s)", fill: ratingSymbol === 'shoe' ? '#c4b89e' : '#eee' }),
        React.createElement(RectForeground, { width: ratingValue * 20 + "%", height: "100%", clipPath: "url(#" + ratingSymbol + "s)" })));
};
var RatingStars = function (_a) {
    var rating = _a.rating, ratingSymbol = _a.ratingSymbol;
    if (!rating || !rating.count)
        return null;
    return (React.createElement(RatingWrapper, { "data-testid": "rating", paddingH: ".5rem" }, ratingSvg(rating.value, ratingSymbol, '5.5rem')));
};
export default withSkeleton(memo(RatingStars), function () { return React.createElement(OwnSkeleton, { width: "80%" }); });
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map